import { render, staticRenderFns } from "./gerenFuncionario.vue?vue&type=template&id=3800b895&scoped=true&"
import script from "./gerenFuncionario.vue?vue&type=script&lang=js&"
export * from "./gerenFuncionario.vue?vue&type=script&lang=js&"
import style0 from "./gerenFuncionario.vue?vue&type=style&index=0&id=3800b895&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3800b895",
  null
  
)

export default component.exports